import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, UserInfo } from '../../../auth.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false,
})
export class HomeComponent implements OnInit {
    user: UserInfo | null = null;
    loadingUser = true;

    constructor(private auth: AuthService, private router: Router) {}

    ngOnInit(): void {
        this.auth.getUser().subscribe((u) => {
            this.user = u;
            this.loadingUser = false;
        });

        this.auth.loadUser().subscribe({
            next: () => {},
            error: () => {
                this.loadingUser = false;
            },
        });
    }

    redirectToMainPage(): void {
        const roles = (this.user?.roles ?? []).map((r) => r.toLowerCase());

        if (roles.includes('baseandwaxesreader')) {
            this.router.navigate(['/base-stock-and-waxes']);
            return;
        }
        if (roles.includes('cogsreader')) {
            this.router.navigate(['/cogs']);
            return;
        }
        if (roles.includes('finishedlubesreader')) {
            this.router.navigate(['/fl']);
            return;
        }

        this.router.navigate(['/access-denied']);
    }

    get displayName(): string {
        const name = this.user?.name ?? '';
        if (!name) return '';
        const parts = name.split(',');
        return parts.length > 1 ? parts[1].trim() : name;
    }

    login(): void {
        this.auth.startLogin();
    }
}
